<script>
  import options from './FilterComponent.options'
  export default options
</script>

<template>
<div>
  <FilterControls v-if="mobileDrawerContext" :mobileDrawerContext="mobileDrawerContext" />
  <article class="nlx-filter-component" id="filterbar" :key="`filter-render-${renderEpoch}`">
    <template v-for="group in facets" :key="group.name">
      <fieldset class="nlx-filter-component__filter">
              <button class="nlx-filter-component__filter-toggle" 
                :id="`filterbutton${group.name}`" 
                :area-controls="`filtergroup${group.name}`" 
                :aria-expanded="!expandedFilters[group.name]"
                @click="expandFilter(group.name)">
                  {{group.displayName}} 
                  <span class="nlx-filter-component__filter-toggle__count">{{group.count}}</span>
                  <div class="nlx-filter-component__chevron">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
                  </div>
              </button>
              <div class="nlx-filter-component__filter-content" 
                :id="`filtergroup${group.name}`" 
                :aria-labelledby="`filterbutton${group.name}`"
                role="region" >

                <template v-for="(facet,facetKey) in group.facets" :key="facetKey">
                  <input class="nlx-filter-component__filter-checkbox" 
                    :id="`filter${group.name}field${facetKey}`" 
                    :checked="facet.selected"
                    type="checkbox">
                  <label class="nlx-filter-component__filter-checkbox-label" 
                    :for="`filter${group.name}field${facetKey}`"
                    @click.prevent="selectFacet(group,facet)">
                    {{facet.displayName}}
                    <span class="nlx-filter-component__filter-toggle__count">{{facet.count}}</span>
                  </label>
                </template>
                <p v-if="group.emptyValueLabel" class="nlx-filter-component__empty-value-label">{{group.emptyValueLabel}}</p>
              </div>
      </fieldset>
    </template>

  </article>
  <template v-if="mobileDrawerContext">
    <div class="nlx-filter-component__mobile-button">
      <button @click="closeMobileFilter" class="nlx-button">{{getLabel('apply_filters')}} ({{filterCount}}) </button>
    </div>
  </template>
</div>
</template>
